export function getAppType() {
  return process.env.apptype
}

export function getServices(server) {
  return `https://${server}.hkvservices.nl`
  /// return "http://localhost"
  // return `http://172.17.18.11`
}

export function getWebServices(server) {
  switch (server) {
    case "tsws":
      return "https://tsgeo.hkv.nl"

    case "dmws":
      return "https://dmgeo.hkv.nl"

    default:
      return "https://geo.hkv.nl"
  }
}

export function getContentUrl(server, application) {
  const service = getServices(server)

  return `${service}/mangrove.data${application}/content`
}

export function getDataUrl(server, functionName, parameters, contentType) {
  const service = getServices(server)

  return `${service}/mangrove_accra.ws/data.ashx?function=${functionName}&parameters=${encodeURIComponent(JSON.stringify(parameters))}&${contentType}`
}

export function getUploadUrl(server) {
  const service = getServices(server)

  return `${service}/mangrove_accra.ws/entry.asmx/Upload`
}

export function getLocalUploadUrl() {
  return "http://localhost/mangrove.ws/entry.asmx/Upload"
}

export function getUrl(server, functionName, parameters) {
  parameters.apptype = getAppType()
  const service = getServices(server)

  return `${service}/mangrove_accra.ws/entry.asmx/Call?function=${functionName}&parameters=${encodeURIComponent(JSON.stringify(parameters))}`
}

export function getLocalUrl(server, functionName, parameters) {
  return `http://localhost/mangrove.ws/entry.asmx/Call?function=${functionName}&parameters=${encodeURIComponent(JSON.stringify(parameters))}`
}
